import React, { useState } from "react";
import {
  useGetProviderBasicProfile,
  useUpdateProviderBasicProfile,
} from "../custom-hooks/queries";
import { useParams } from "react-router-dom";
import CustomButton from "./CustomButton";
import { HttpsUrlInputStandalone } from "./HttpsUrlInput";

export const BasicProfile = () => {
  const { id } = useParams();
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});

  const basicData = {
    id: "prov-001",
    name: "Alpha Labs",
    url: "https://www.alphalabs.com",
    address1: "123 Innovation Drive",
    city: "New York",
    zip: "10001",
    country: "USA",
    phone_number: "+1-800-555-1234",
    description:
      "Alpha Labs is a leading diagnostics company providing advanced laboratory services across the United States.",
    logo: "https://via.placeholder.com/150x80?text=Alpha+Labs",
    provider_type: "Laboratory",
    rfi_count: 5,
    assessment_count: 3,
    year_founded: 2005,
    secondary_locations: [
      {
        address1: "456 Health Blvd",
        city: "Chicago",
        zip: "60601",
        country: "USA",
        address2: "Suite 300",
        state: "IL",
      },
      {
        address1: "789 Care Ave",
        city: "Los Angeles",
        zip: "90001",
        country: "USA",
        address2: "Floor 2",
        state: "CA",
      },
    ],
    languages: ["English", "Spanish"],
    are_additional_locations_available: true,
    additional_locations_count: 2,
    are_capabilities_same_across_locations: false,
    locations_quality_management_system: "Localized",
    geographic_regions_served: [
      {
        id: "region-001",
        goegraphical_region: "North America",
      },
      {
        id: "region-002",
        goegraphical_region: "Europe",
      },
    ],
    therapeutic_areas_supported: [
      {
        id: "ta-001",
        therapeutic_area: "Oncology",
      },
      {
        id: "ta-002",
        therapeutic_area: "Cardiology",
      },
    ],
    indications: [
      {
        id: "ind-001",
        indication: "Lung Cancer",
        therapeutic_area_id: "ta-001",
      },
      {
        id: "ind-002",
        indication: "Heart Failure",
        therapeutic_area_id: "ta-002",
      },
    ],
    capabilities: [
      {
        rfi_id: "rfi-001",
        rfi_name: "Blood Test",
      },
      {
        rfi_id: "rfi-002",
        rfi_name: "Genetic Screening",
      },
    ],
    other_capabilities: [
      "Home Sample Collection",
      "Real-time Reporting Dashboard",
    ],
    service_compliance_types: [
      {
        id: "sct-001",
        service_compliance_type: "CLIA Certified",
      },
      {
        id: "sct-002",
        service_compliance_type: "HIPAA Compliant",
      },
    ],
    is_audit_report_available: true,
    is_rfi_available: true,
    address2: "Suite 100",
    state: "NY",
    number_of_sponsors_served: 12,
  };

  const { data: basicProfile, isLoading } = useGetProviderBasicProfile(id);
  const updateProfile = useUpdateProviderBasicProfile();

  const handleEdit = () => {
    setIsEditing(true);
    setFormData(basicProfile || {});
  };

  const handleCancel = () => {
    setIsEditing(false);
    setFormData({});
  };

  const handleSave = async () => {
    try {
      await updateProfile.mutateAsync({ id, data: formData });
      setIsEditing(false);
    } catch (error) {
      console.error("Error saving profile:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // if (isLoading) {
  //   return <div>Loading...</div>;
  // }

  // if (!basicProfile) {
  //   return <div>No data available</div>;
  // }

  return (
    <div className="px-4 py-6 space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-base font-semibold text-gray-700">
          Basic Information
        </h2>
        {/* {!isEditing && (
          <CustomButton
            color="bg-indigo-600"
            size="text-sm"
            weight="font-normal"
            height="h-8"
            width="w-20"
            textColor="text-white"
            text="Edit"
            borderRadius="0.375rem"
            onClick={handleEdit}
          />
        )} */}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <p className="text-sm font-medium text-black">Name</p>
          {isEditing ? (
            <input
              type="text"
              name="name"
              value={formData.name || ""}
              onChange={handleChange}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          ) : (
            <p className="text-sm text-gray-700">{basicData.name || "N/A"}</p>
          )}
          <hr className="mt-2 border-t border-gray-200" />
        </div>

        <div>
          <p className="text-sm font-medium text-black">Website</p>
          {isEditing ? (
            <HttpsUrlInputStandalone
              name="url"
              label=""
              placeholder="www.vendorwebsite.com"
              value={formData.url || ""}
              onChange={(v) =>
                setFormData((prev) => ({ ...prev, url: v }))
              }
            />
          ) : (
            <a
              href={basicData.url || "#"}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-indigo-600 hover:underline"
            >
              {basicData.url || "N/A"}
            </a>
          )}
          <hr className="mt-2 border-t border-gray-200" />
        </div>

        <div>
          <p className="text-sm font-medium text-black">Address</p>
          {isEditing ? (
            <input
              type="text"
              name="address1"
              value={formData.address1 || ""}
              onChange={handleChange}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          ) : (
            <p className="text-sm text-gray-700">{basicData.address1}</p>
          )}
          <hr className="mt-2 border-t border-gray-200" />
        </div>

        <div>
          <p className="text-sm font-medium text-black">City, State, Zip</p>
          {isEditing ? (
            <div className="grid grid-cols-3 gap-2">
              <input
                type="text"
                name="city"
                value={formData.city || ""}
                onChange={handleChange}
                placeholder="City"
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
              <input
                type="text"
                name="state"
                value={formData.state || ""}
                onChange={handleChange}
                placeholder="State"
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
              <input
                type="text"
                name="zip"
                value={formData.zip || ""}
                onChange={handleChange}
                placeholder="Zip"
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
            </div>
          ) : (
            <p className="text-sm text-gray-700">
              {basicData.city}, {basicData.state} {basicData.zip}
            </p>
          )}
          <hr className="mt-2 border-t border-gray-200" />
        </div>

        <div>
          <p className="text-sm font-medium text-black">Country</p>
          {isEditing ? (
            <input
              type="text"
              name="country"
              value={formData.country || ""}
              onChange={handleChange}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          ) : (
            <p className="text-sm text-gray-700">
              {basicData.country || "N/A"}
            </p>
          )}
          <hr className="mt-2 border-t border-gray-200" />
        </div>

        <div>
          <p className="text-sm font-medium text-black">Phone Number</p>
          {isEditing ? (
            <input
              type="text"
              name="phone_number"
              value={formData.phone_number || ""}
              onChange={handleChange}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          ) : (
            <p className="text-sm text-gray-700">
              {basicData.phone_number || "N/A"}
            </p>
          )}
          <hr className="mt-2 border-t border-gray-200" />
        </div>

        <div>
          <p className="text-sm font-medium text-black">Provider Type</p>
          {isEditing ? (
            <input
              type="text"
              name="provider_type"
              value={formData.provider_type || ""}
              onChange={handleChange}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          ) : (
            <p className="text-sm text-gray-700">
              {basicData.provider_type || "N/A"}
            </p>
          )}
          <hr className="mt-2 border-t border-gray-200" />
        </div>

        <div>
          <p className="text-sm font-medium text-black">Year Founded</p>
          {isEditing ? (
            <input
              type="text"
              name="year_founded"
              value={formData.year_founded || ""}
              onChange={handleChange}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          ) : (
            <p className="text-sm text-gray-700">
              {basicData.year_founded || "N/A"}
            </p>
          )}
          <hr className="mt-2 border-t border-gray-200" />
        </div>
      </div>

      {isEditing && (
        <div className="flex justify-end space-x-4 mt-6">
          <CustomButton
            color="bg-gray-200"
            size="text-sm"
            weight="font-normal"
            height="h-8"
            width="w-20"
            textColor="text-gray-700"
            text="Cancel"
            borderRadius="0.375rem"
            onClick={handleCancel}
          />
          <CustomButton
            color="bg-indigo-600"
            size="text-sm"
            weight="font-normal"
            height="h-8"
            width="w-20"
            textColor="text-white"
            text="Save"
            borderRadius="0.375rem"
            onClick={handleSave}
          />
        </div>
      )}

      {basicData?.secondary_locations?.length > 0 && (
        <div>
          <h2 className="text-base font-semibold text-gray-700 mb-2">
            Secondary Locations
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {basicData?.secondary_locations.map((location, index) => (
              <div key={index}>
                <p className="text-sm font-medium text-black">
                  Location {index + 1}
                </p>
                <p className="text-sm text-gray-700">
                  {/* {location?.address1} {location?.address2} */}
                  <br />
                  {location?.city}, {location?.state} {location?.zip}
                  <br />
                  {location.country}
                </p>
                <hr className="mt-2 border-t border-gray-200" />
              </div>
            ))}
          </div>
        </div>
      )}

      {basicData.languages?.length > 0 && (
        <div>
          <h2 className="text-base font-semibold text-gray-700 mb-2">
            Languages
          </h2>
          <p className="text-sm text-gray-700">
            {basicData.languages.join(", ")}
          </p>
        </div>
      )}
    </div>
  );
};
